import { PostponeStepSchema } from '@feedyou/schema'

import { GetUsedDialogs } from '../../../types'

export const getUsedDialogs: GetUsedDialogs<PostponeStepSchema> = (step, enabledOnly = false) => {
  if (enabledOnly && step.disabled) {
    return []
  }

  return step.dialog ? [step.dialog] : []
}
